import useI18n from '@/shared/hooks/useI18n'
import { isAfter, isBefore } from 'date-fns'
import { SelectGroup } from '@/common'

export const getInitialReportingPeriod = (
  reportingPeriods: { startDate: string; endDate: string }[]
): { value: string; startDate: string; endDate: string } => {
  const today = new Date()
  const currentPeriod = reportingPeriods.find(period => {
    return isAfter(today, period.startDate) && isBefore(today, period.endDate)
  })

  if (currentPeriod) {
    return {
      value: currentPeriod.startDate,
      startDate: currentPeriod.startDate,
      endDate: currentPeriod.endDate
    }
  }

  return {
    value: reportingPeriods[0].startDate,
    startDate: reportingPeriods[0].startDate,
    endDate: reportingPeriods[0].endDate
  }
}

export default function ReportingPeriodsSelector({
  selectedReportingPeriod,
  reportingPeriods,
  reportingPeriodBasis,
  onChange
}: {
  selectedReportingPeriod: { value: string | null; startDate?: string; endDate?: string }
  reportingPeriods: { startDate: string; endDate: string }[]
  reportingPeriodBasis: string
  onChange: (value: string | null, startDate?: string, endDate?: string) => void
}) {
  const { dateLongFormatterMonthYear } = useI18n()

  const reportingPeriodOptions = reportingPeriods.map(period => ({
    value: period.startDate,
    startDate: period.startDate,
    endDate: period.endDate,
    label:
      reportingPeriodBasis === 'CALENDAR_YEAR'
        ? `${new Date(period.startDate).getFullYear()}`
        : `${dateLongFormatterMonthYear(new Date(period.startDate))} - ${dateLongFormatterMonthYear(new Date(period.endDate))}`
  }))

  const onSelectedPeriodChange = (value: string) => {
    if (value === '') {
      onChange(null)
      return
    }

    const selectedPeriod = reportingPeriodOptions.find(period => period.value === value)

    if (selectedPeriod) {
      onChange(selectedPeriod.value, selectedPeriod.startDate, selectedPeriod.endDate)
    }
  }

  return (
    <div className="w-48">
      <SelectGroup
        value={selectedReportingPeriod?.value ?? ''}
        onChange={(evt): void => onSelectedPeriodChange(evt.target.value)}
        options={reportingPeriodOptions}
      />
    </div>
  )
}
